import React, { useEffect, useMemo, useState } from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import WidgetHeaderControls from './WidgetHeaderControls';

const WidgetPlan = ({
  vuesFavorites = [],
  onVueClick,
  headerContent = null,
  showHeader = true,
}) => {
  // Afficher une vue favorite ou une image placeholder
  const hasVue = vuesFavorites && vuesFavorites.length > 0;
  const [selectedVueIndex, setSelectedVueIndex] = useState('0');
  const vuesLength = vuesFavorites?.length || 0;

  useEffect(() => {
    if (!hasVue) {
      setSelectedVueIndex('0');
      return;
    }

    const currentIndex = Number(selectedVueIndex);
    if (currentIndex >= vuesLength) {
      setSelectedVueIndex('0');
    }
  }, [hasVue, vuesLength, selectedVueIndex]);

  const vueOptions = useMemo(() => {
    if (!hasVue || vuesLength < 2) {
      return [];
    }

    return vuesFavorites.map((vue, index) => ({
      value: String(index),
      label: vue.view_name || `${checkMot('plan')} ${index + 1}`,
    }));
  }, [hasVue, vuesFavorites, vuesLength]);

  const currentVue = hasVue
    ? vuesFavorites[Number(selectedVueIndex)] || vuesFavorites[0]
    : null;

  const resolvedHeader =
    headerContent ||
    (showHeader ? (
      <WidgetHeaderControls
        titleKey="plan"
        selectOptions={vueOptions}
        selectedValue={selectedVueIndex}
        onSelectChange={setSelectedVueIndex}
      />
    ) : null);

  return (
    <div className={[S.widget, S.widgetLarge].join(' ')}>
      {resolvedHeader}
      <div className={S.widgetContent}>
        {hasVue ? (
          <div className={S.planContainer}>
            {/* Afficher la première vue favorite comme aperçu */}
            <div
              className={S.planPreview}
              onClick={() => onVueClick && currentVue && onVueClick(currentVue)}
            >
              <img
                src={currentVue?.image_url || 'https://tile.openstreetmap.org/5/15/11.png'}
                alt={currentVue?.view_name || checkMot('plan')}
                className={S.planImage}
              />
            </div>
          </div>
        ) : (
          <div className={S.emptyState}>
            <div className={S.mapPlaceholder}>
              <img 
                src="https://tile.openstreetmap.org/5/15/11.png" 
                alt="map placeholder"
                className={S.planImage}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetPlan;
